import { baseApi } from '@app/store/index.api';

import {
  ITokenBuyResponse,
  IApproveTokenBuyQuery,
  IApproveTokenBuyResponse,
  IRejectTokenBuyQuery,
  IRejectTokenBuyResponse,
} from '../model/types';

const tokenBuyApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTokenBuys: builder.query<ITokenBuyResponse, string>({
      query: query => {
        return {
          url: `pd/trader-orders?filter[type][]=buyToken&${query}`,
        };
      },
    }),
    approveTokenBuy: builder.mutation<IApproveTokenBuyResponse, IApproveTokenBuyQuery>({
      query: query => {
        return {
          url: `/pd/settlement/${query.id}/approve`,
          method: 'PATCH',
          body: query,
        };
      },
    }),
    rejectTokenBuy: builder.mutation<IRejectTokenBuyResponse, IRejectTokenBuyQuery>({
      query: query => {
        return {
          url: `/pd/settlement/${query.id}/reject`,
          method: 'PATCH',
          body: query,
        };
      },
    }),
  }),
});

export const {
  useGetTokenBuysQuery,
  useApproveTokenBuyMutation,
  useRejectTokenBuyMutation,
} = tokenBuyApi;
